<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("BUTTONS.add_notification") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #3eb6d4">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <!-- Start:: Title Ar Input -->
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.titleAr')"
                v-model.trim="data.titleAr"
                required
              />
              <!-- End:: Title Ar Input -->

              <!-- Start:: Title En Input -->
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.titleEn')"
                v-model.trim="data.titleEn"
                required
              />
              <!-- End:: Title En Input -->

              <!-- Start:: Content Ar Input -->
              <base-input
                col="6"
                rows="7"
                type="textarea"
                :placeholder="$t('PLACEHOLDERS.contentAr')"
                v-model.trim="data.contentAr"
                required
              />
              <!-- End:: Content Ar Input -->

              <!-- Start:: Content En Input -->
              <base-input
                col="6"
                rows="7"
                type="textarea"
                :placeholder="$t('PLACEHOLDERS.contentEn')"
                v-model.trim="data.contentEn"
                required
              />
              <!-- End:: Content En Input -->
            </div>
          </div>
          <!-- Start:: Receiver Type Input -->
          <base-select-input
            col="6"
            :optionsList="receiverTypes"
            :placeholder="$t('PLACEHOLDERS.receiverType')"
            v-model="data.receiverType"
            required
          />
          <!-- End:: Receiver Type Input -->

          <!-- Start:: Clients Type Input -->
          <base-select-input
            v-if="data.clients && data.receiverType.value === 'allClients'"
            col="6"
            :optionsList="data.clients"
            :placeholder="$t('PLACEHOLDERS.clients_menu')"
            v-model="data.client"
            required
            multiple
          />

          <base-select-input
            v-if="data.providers && data.receiverType.value === 'allProviders'"
            col="6"
            :optionsList="data.providers"
            :placeholder="$t('PLACEHOLDERS.serviceProviders')"
            v-model="data.provider"
            required
            multiple
          />

          <base-select-input
            v-if="data.representatives && data.receiverType.value === 'allRepresentatives'"
            col="6"
            :optionsList="data.representatives"
            :placeholder="$t('PLACEHOLDERS.representatives')"
            v-model="data.representative"
            required
            multiple
          />
          <!-- End:: Clients Type Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CreateNotification",

  
  computed: {
    // Start:: Vuex Getters
    ...mapGetters({
      allClientsData: "ApiGetsModule/allClientsData",
      allDriversData: "ApiGetsModule/allDriversData",
    }),
    // End:: Vuex Getters

    receiverTypes() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.clientsRequest"),
          value: "allClients",
        },
        {
          id: 3,
          name: this.$t("PLACEHOLDERS.serviceProviders"),
          value: "allProviders",
        },
        {
          id: 4,
          name: this.$t("PLACEHOLDERS.representatives"),
          value: "allRepresentatives",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.all"),
          value: "all",
        },
      ];
    },
  },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        receiverType: {
          id: null,
          name: null,
          value: null,
        },
        clients: [],
        providers: [],
        representatives: [],
        client: [],
        provider: [],
        representative: [],
        titleAr: null,
        titleEn: null,
        contentAr: null,
        contentEn: null,
      },

      // End:: Data Collection To Send
    };
  },

  methods: {
    // End:: Vuex Actions

    async getClients() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `clients?page=0&limit=0&isActive=1`,
        });

        // تحويل البيانات من {user: {...}} إلى {...} مباشرة
        this.data.clients = res.data.data.data.map(item => {
          const name = item.user?.name || item.name;
          const mobile = item.user?.mobile || item.mobile;
          return {
            id: item.user?.id || item.id,
            name: mobile ? `${name} (${mobile})` : name,
            mobile: mobile,
            email: item.user?.email || item.email,
            avatar: item.user?.avatar || item.avatar,
          };
        });
      } catch (error) {
        console.log(error.response?.data?.message || error.message);
      }
    },

    async getProviders() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `printShops?page=0&limit=0&isActive=1`,
        });
        
        // تحويل البيانات من {user: {...}} إلى {...} مباشرة
        this.data.providers = res.data.data.data.map(item => {
          const name = item.user?.name || item.name;
          const mobile = item.user?.mobile || item.mobile;
          return {
            id: item.user?.id || item.id,
            name: mobile ? `${name} (${mobile})` : name,
            mobile: mobile,
            email: item.user?.email || item.email,
            avatar: item.user?.avatar || item.avatar,
          };
        });
      } catch (error) {
        console.log(error.response?.data?.message || error.message);
      }
    },

    async getRepresentatives() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `representatives?page=0&limit=0&isActive=1`,
        });
        
        // تحويل البيانات من {user: {...}} إلى {...} مباشرة
        this.data.representatives = res.data.data.data.map(item => {
          const name = item.user?.name || item.name;
          const mobile = item.user?.mobile || item.mobile;
          return {
            id: item.user?.id || item.id,
            name: mobile ? `${name} (${mobile})` : name,
            mobile: mobile,
            email: item.user?.email || item.email,
            avatar: item.user?.avatar || item.avatar,
          };
        });
      } catch (error) {
        console.log(error.response?.data?.message || error.message);
      }
    },

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      // else
      if (!this.data.titleAr) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.titleAr"));
        return;
      } else if (!this.data.titleEn) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.titleEn"));
        return;
      } else if (!this.data.contentAr) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.contentAr"));
        return;
      } else if (!this.data.contentEn) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.contentEn"));
        return;
      } else if (!this.data.receiverType || !this.data.receiverType.value) {
        this.isWaitingRequest = false;
        this.$message.error("يجب اختيار نوع المستلم");
        return;
      } else {
        this.submitForm();
        return;
      }
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      
      // Start:: Append Basic Data
      REQUEST_DATA.append("title_ar", this.data.titleAr);
      REQUEST_DATA.append("title_en", this.data.titleEn);
      REQUEST_DATA.append("body_ar", this.data.contentAr);
      REQUEST_DATA.append("body_en", this.data.contentEn);
      // End:: Append Basic Data

      // Start:: Handle Receiver Type and IDs
      let type = "";
      let to_all = 0;
      let ids = [];

      if (this.data.receiverType.value == "allClients") {
        type = "client";
        if (this.data.client && this.data.client.length > 0) {
          to_all = 0;
          ids = this.data.client.map((element) => element.id);
        } else {
          to_all = 1;
        }
      } else if (this.data.receiverType.value == "allProviders") {
        type = "printShop";
        if (this.data.provider && this.data.provider.length > 0) {
          to_all = 0;
          ids = this.data.provider.map((element) => element.id);
        } else {
          to_all = 1;
        }
      } else if (this.data.receiverType.value == "allRepresentatives") {
        type = "representative";
        if (this.data.representative && this.data.representative.length > 0) {
          to_all = 0;
          ids = this.data.representative.map((element) => element.id);
        } else {
          to_all = 1;
        }
      } else if (this.data.receiverType.value == "all") {
        type = "all";
        to_all = 1;
      }

      REQUEST_DATA.append("type", type);
      REQUEST_DATA.append("to_all", to_all.toString());
      
      // Append IDs if to_all is 0
      if (to_all == 0 && ids.length > 0) {
        ids.forEach((id) => {
          REQUEST_DATA.append("ids[]", id);
        });
      }
      // End:: Handle Receiver Type and IDs

      try {
        await this.$axios({
          method: "POST",
          url: `notification/store`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.sentSuccessfully"));
        this.$router.push({ path: "/all-notifications/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        if (error.response?.data?.errors) {
          const errors = error.response.data.errors;
          const errorMessages = Object.values(errors).flat().join(", ");
          this.$message.error(errorMessages);
        } else {
          this.$message.error(error.response?.data?.message || "حدث خطأ أثناء إرسال الإشعار");
        }
      }
    },
    // End:: Submit Form
  },

  created() {
    // Start:: Fire Methods
    this.getClients();
    this.getProviders();
    this.getRepresentatives();
    // End:: Fire Methods
  },
};
</script>
